export const MOBILE_MAX_WIDTH = 480;
export const TABLET_MAX_WIDTH = 768;
export const DESKTOP_MIN_WIDTH = 1025;

export function isMobile(): boolean {
  return window.innerWidth <= TABLET_MAX_WIDTH;
}
